module.exports = __webpack_public_path__ + "img/grilled-pork-tenderloin.d4c401e5.jpg";